<template>
  <section>
    <h3 class="h-title">主体文件<div class="h-tag">（注：所上传文件的复印件加盖业务申请人公章）</div></h3>  
    <el-form class="e-form f-b" ref="cForm4" :model="cForm4" label-width="250px"  label-position="left">
      <!-- 债权人 -->
      <el-form-item label="债权人名称" prop="creditorName">
        <el-input v-model="cForm4.creditorName" disabled/>
      </el-form-item>
      <el-form-item class="w-70" label="三证合一" prop="creditorThreeCertOneFile" :rules="[{ type: 'array', required: true, message: '请上传', trigger: 'change' }]">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'creditorThreeCertOneFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'creditorThreeCertOneFile')" 
            :on-error="handleError"
            :file-list="cForm4.creditorThreeCertOneFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="法定代表人身份证" prop="creditorIdentityCardFile" :rules="[{ type: 'array', required: true, message: '请上传', trigger: 'change' }]">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'creditorIdentityCardFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'creditorIdentityCardFile')" 
            :on-error="handleError"
            :file-list="cForm4.creditorIdentityCardFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="公司简介" prop="creditorCompanyProfileFile" :rules="[{ type: 'array', required: true, message: '请上传', trigger: 'change' }]">
        <el-upload
            class="upload-part"
            :limit="1" 
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'creditorCompanyProfileFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'creditorCompanyProfileFile')" 
            :on-error="handleError"
            :file-list="cForm4.creditorCompanyProfileFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="公司章程" prop="creditorCompanyByelawFile" :rules="[{ type: 'array', required: true, message: '请上传', trigger: 'change' }]">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'creditorCompanyByelawFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'creditorCompanyByelawFile')" 
            :on-error="handleError"
            :file-list="cForm4.creditorCompanyByelawFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="高管人员简历" prop="creditorGgPersonResumeFile" :rules="[{ type: 'array', required: true, message: '请上传', trigger: 'change' }]">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'creditorGgPersonResumeFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'creditorGgPersonResumeFile')" 
            :on-error="handleError"
            :file-list="cForm4.creditorGgPersonResumeFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="近两年财务报表及近一期财务报表" prop="creditorFinanceReportFile" :rules="[{ type: 'array', required: true, message: '请上传', trigger: 'change' }]">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'creditorFinanceReportFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'creditorFinanceReportFile')" 
            :on-error="handleError"
            :file-list="cForm4.creditorFinanceReportFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="灰名单查询结果" prop="creditorRiskResultFile" :rules="[{ type: 'array', required: true, message: '请上传', trigger: 'change' }]">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'creditorRiskResultFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'creditorRiskResultFile')" 
            :on-error="handleError"
            :file-list="cForm4.creditorRiskResultFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item label="电子邮箱" prop="creditorMail" :rules="[{ pattern:  /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/, required: true, message: '请输入正确的邮箱', trigger: 'blur' }]">
        <el-input v-model="cForm4.creditorMail" placeholder="请输入" />
      </el-form-item>
      <el-form-item class="w-70" label="征信报告" prop="creditorCreditReportFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'creditorCreditReportFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'creditorCreditReportFile')" 
            :on-error="handleError"
            :file-list="cForm4.creditorCreditReportFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="信用报告" prop="creditorThinktankReportFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'creditorThinktankReportFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'creditorThinktankReportFile')" 
            :on-error="handleError"
            :file-list="cForm4.creditorThinktankReportFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <!-- 债权人end -->
      <el-divider></el-divider>
      <!-- 债务人 -->
      <el-form-item label="债务人名称" prop="debtorName">
        <el-input v-model="cForm4.debtorName" disabled/>
      </el-form-item>
      <el-form-item class="w-70" label="三证合一" prop="debtorThreeCertOneFile" :rules="[{ type: 'array', required: true, message: '请上传', trigger: 'change' }]">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'debtorThreeCertOneFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'debtorThreeCertOneFile')" 
            :on-error="handleError"
            :file-list="cForm4.debtorThreeCertOneFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="法定代表人身份证" prop="debtorIdentityCardFile" :rules="[{ type: 'array', required: true, message: '请上传', trigger: 'change' }]">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'debtorIdentityCardFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'debtorIdentityCardFile')" 
            :on-error="handleError"
            :file-list="cForm4.debtorIdentityCardFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="公司简介" prop="debtorCompanyProfileFile" :rules="[{ type: 'array', required: true, message: '请上传', trigger: 'change' }]">
        <el-upload
            class="upload-part"
            :limit="1" 
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'debtorCompanyProfileFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'debtorCompanyProfileFile')" 
            :on-error="handleError"
            :file-list="cForm4.debtorCompanyProfileFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="公司章程" prop="debtorCompanyByelawFile" :rules="[{ type: 'array', required: true, message: '请上传', trigger: 'change' }]">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'debtorCompanyByelawFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'debtorCompanyByelawFile')" 
            :on-error="handleError"
            :file-list="cForm4.debtorCompanyByelawFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="高管人员简历" prop="debtorGgPersonResumeFile" :rules="[{ type: 'array', required: true, message: '请上传', trigger: 'change' }]">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'debtorGgPersonResumeFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'debtorGgPersonResumeFile')" 
            :on-error="handleError"
            :file-list="cForm4.debtorGgPersonResumeFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="近两年财务报表及近一期财务报表" prop="debtorFinanceReportFile" :rules="[{ type: 'array', required: true, message: '请上传', trigger: 'change' }]">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'debtorFinanceReportFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'debtorFinanceReportFile')" 
            :on-error="handleError"
            :file-list="cForm4.debtorFinanceReportFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="灰名单查询结果" prop="debtorRiskResultFile" :rules="[{ type: 'array', required: true, message: '请上传', trigger: 'change' }]">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'debtorRiskResultFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'debtorRiskResultFile')" 
            :on-error="handleError"
            :file-list="cForm4.debtorRiskResultFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item label="电子邮箱" prop="debtorMail" :rules="[{ pattern:  /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/, required: true, message: '请输入正确的邮箱', trigger: 'blur' }]">
        <el-input v-model="cForm4.debtorMail" placeholder="请输入" />
      </el-form-item>
      <el-form-item class="w-70" label="征信报告" prop="debtorCreditReportFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'debtorCreditReportFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'debtorCreditReportFile')" 
            :on-error="handleError"
            :file-list="cForm4.debtorCreditReportFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="信用报告" prop="debtorThinktankReportFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'debtorThinktankReportFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'debtorThinktankReportFile')" 
            :on-error="handleError"
            :file-list="cForm4.debtorThinktankReportFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <!-- 债务人end -->
    </el-form>
    <el-form class="e-form f-b" ref="subjectFile" :model="subjectFile" label-width="250px"  label-position="left">
      <!-- 增信主体 -->
      <div v-for="index in cForm4.subjectNum" :key="'main'+index" >
        <div v-if="cForm4[`subjectName${index}`]">
          <el-divider></el-divider>
          <el-form-item :label="`增信主体${index}名称`" >
            <el-input v-model="cForm4[`subjectName${index}`]" disabled/>
          </el-form-item>
          <el-form-item class="w-70" label="三证合一" :prop="`subjectThreeCertOneFile${index}`" :rules="[{ type: 'array', required: true, message: '请上传', trigger: 'change' }]">
            <el-upload
                class="upload-part"
                :limit="1"
                :action="action"
                :headers = "headers"
                :before-upload="(file) => beforeUpload(file)"
                :on-remove="(file, fileList) => handleRemoveSub(file, fileList, 'subjectThreeCertOneFile', index)"
                :on-success="(response, file, fileList) => uploadSub(response, file, fileList, 'subjectThreeCertOneFile', index)" 
                :on-error="handleError"
                :file-list="subjectFile[`subjectThreeCertOneFile${index}`] || []">
                <el-button size="small" type="orange">上传</el-button>
            </el-upload>
          </el-form-item> 
          <el-form-item class="w-70" label="法定代表人身份证" :prop="`subjectIdentityCardFile${index}`" :rules="[{ type: 'array', required: true, message: '请上传', trigger: 'change' }]">
            <el-upload
                class="upload-part"
                :limit="1"
                :action="action"
                :headers = "headers"
                :before-upload="(file) => beforeUpload(file)"
                :on-remove="(file, fileList) => handleRemoveSub(file, fileList, 'subjectIdentityCardFile', index)"
                :on-success="(response, file, fileList) => uploadSub(response, file, fileList, 'subjectIdentityCardFile', index)" 
                :on-error="handleError"
                :file-list="subjectFile[`subjectIdentityCardFile${index}`] || []">
                <el-button size="small" type="orange">上传</el-button>
            </el-upload>
          </el-form-item> 
          <el-form-item class="w-70" label="公司简介" :prop="`subjectCompanyProfileFile${index}`" :rules="[{ type: 'array', required: true, message: '请上传', trigger: 'change' }]">
            <el-upload
                class="upload-part"
                :limit="1" 
                :action="action"
                :headers = "headers"
                :before-upload="(file) => beforeUpload(file)"
                :on-remove="(file, fileList) => handleRemoveSub(file, fileList, 'subjectCompanyProfileFile', index)"
                :on-success="(response, file, fileList) => uploadSub(response, file, fileList, 'subjectCompanyProfileFile', index)" 
                :on-error="handleError"
                :file-list="subjectFile[`subjectCompanyProfileFile${index}`] || []">
                <el-button size="small" type="orange">上传</el-button>
            </el-upload>
          </el-form-item> 
          <el-form-item class="w-70" label="公司章程" :prop="`subjectCompanyByelawFile${index}`" :rules="[{ type: 'array', required: true, message: '请上传', trigger: 'change' }]">
            <el-upload
                class="upload-part"
                :limit="1"
                :action="action"
                :headers = "headers"
                :before-upload="(file) => beforeUpload(file)"
                :on-remove="(file, fileList) => handleRemoveSub(file, fileList, 'subjectCompanyByelawFile', index)"
                :on-success="(response, file, fileList) => uploadSub(response, file, fileList, 'subjectCompanyByelawFile', index)" 
                :on-error="handleError"
                :file-list="subjectFile[`subjectCompanyByelawFile${index}`] || []">
                <el-button size="small" type="orange">上传</el-button>
            </el-upload>
          </el-form-item> 
          <el-form-item class="w-70" label="高管人员简历" :prop="`subjectGgPersonResumeFile${index}`" :rules="[{ type: 'array', required: true, message: '请上传', trigger: 'change' }]">
            <el-upload
                class="upload-part"
                :limit="1"
                :action="action"
                :headers = "headers"
                :before-upload="(file) => beforeUpload(file)"
                :on-remove="(file, fileList) => handleRemoveSub(file, fileList, 'subjectGgPersonResumeFile', index)"
                :on-success="(response, file, fileList) => uploadSub(response, file, fileList, 'subjectGgPersonResumeFile', index)" 
                :on-error="handleError"
                :file-list="subjectFile[`subjectGgPersonResumeFile${index}`] || []">
                <el-button size="small" type="orange">上传</el-button>
            </el-upload>
          </el-form-item> 
          <el-form-item class="w-70" label="近两年财务报表及近一期财务报表" :prop="`subjectFinanceReportFile${index}`" :rules="[{ type: 'array', required: true, message: '请上传', trigger: 'change' }]">
            <el-upload
                class="upload-part"
                :limit="1"
                :action="action"
                :headers = "headers"
                :before-upload="(file) => beforeUpload(file)"
                :on-remove="(file, fileList) => handleRemoveSub(file, fileList, 'subjectFinanceReportFile', index)"
                :on-success="(response, file, fileList) => uploadSub(response, file, fileList, 'subjectFinanceReportFile', index)" 
                :on-error="handleError"
                :file-list="subjectFile[`subjectFinanceReportFile${index}`] || []">
                <el-button size="small" type="orange">上传</el-button>
            </el-upload>
          </el-form-item> 
          <el-form-item class="w-70" label="灰名单查询结果" :prop="`subjectRiskResultFile${index}`" :rules="[{ type: 'array', required: true, message: '请上传', trigger: 'change' }]">
            <el-upload
                class="upload-part"
                :limit="1"
                :action="action"
                :headers = "headers"
                :before-upload="(file) => beforeUpload(file)"
                :on-remove="(file, fileList) => handleRemoveSub(file, fileList, 'subjectRiskResultFile', index)"
                :on-success="(response, file, fileList) => uploadSub(response, file, fileList, 'subjectRiskResultFile', index)" 
                :on-error="handleError"
                :file-list="subjectFile[`subjectRiskResultFile${index}`] || []">
                <el-button size="small" type="orange">上传</el-button>
            </el-upload>
          </el-form-item> 
          <el-form-item label="电子邮箱" :prop="`subjectMail${index}`" :rules="[{ pattern:  /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/, required: true, message: '请输入正确的邮箱', trigger: 'blur' }]">
            <el-input v-model="subjectFile[`subjectMail${index}`]" placeholder="请输入" />
          </el-form-item>
          <el-form-item class="w-70" label="征信报告" prop="subjectCreditReportFile">
            <el-upload
                class="upload-part"
                :limit="1"
                :action="action"
                :headers = "headers"
                :before-upload="(file) => beforeUpload(file)"
                :on-remove="(file, fileList) => handleRemoveSub(file, fileList, 'subjectCreditReportFile', index)"
                :on-success="(response, file, fileList) => uploadSub(response, file, fileList, 'subjectCreditReportFile', index)" 
                :on-error="handleError"
                :file-list="subjectFile[`subjectCreditReportFile${index}`] || []">
                <el-button size="small" type="orange">上传</el-button>
            </el-upload>
          </el-form-item> 
          <el-form-item class="w-70" label="信用报告" :prop="`subjectThinktankReportFile${index}`">
            <el-upload
                class="upload-part"
                :limit="1"
                :action="action"
                :headers = "headers"
                :before-upload="(file) => beforeUpload(file)"
                :on-remove="(file, fileList) => handleRemoveSub(file, fileList, 'subjectThinktankReportFile', index)"
                :on-success="(response, file, fileList) => uploadSub(response, file, fileList, 'subjectThinktankReportFile', index)" 
                :on-error="handleError"
                :file-list="subjectFile[`subjectThinktankReportFile${index}`] || []">
                <el-button size="small" type="orange">上传</el-button>
            </el-upload>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <!-- 按钮 -->					
    <div class="cenrer">	
      <el-button class="s-but" type="orange" @click.native="prev">上一步</el-button>	
      <el-button class="s-but" type="orange" @click="cSubmitForm('0')" :loading="butLoading">保 存</el-button>
      <el-button class="s-but" type="orange" @click.native="cSubmitForm('1')" :loading="butLoading">下一步</el-button>
    </div>
  </section>
</template>
<script>
import baseUrl from '@/api/baseUrl.js'
import { elFormErrorScrollIntoView } from '@/utils/util'
export default {
    name: "step4",
    props: ["active"],
		data() {
			return { 
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("token")
        },      
        cForm4: {},
        subjectFile: {},
        action: '',
        butLoading: false,       
        account: sessionStorage.account,
			}
    },
    watch: {
      active(newVal) {
        if(newVal == 4) {
          this.action = `${baseUrl.iaccUrl}/iacc-contract-platform/common/uploadFile`;
          // this.action = `http://172.30.15.232:9097/common/uploadFile`;
          this.cForm4 = JSON.parse(sessionStorage.setpForm);
          // 债权人
          this.cForm4.creditorThreeCertOneFile = JSON.parse(this.cForm4.creditorThreeCertOneFile || '[]');
          this.cForm4.creditorIdentityCardFile = JSON.parse(this.cForm4.creditorIdentityCardFile || '[]');
          this.cForm4.creditorCompanyProfileFile = JSON.parse(this.cForm4.creditorCompanyProfileFile || '[]');
          this.cForm4.creditorCompanyByelawFile = JSON.parse(this.cForm4.creditorCompanyByelawFile || '[]');
          this.cForm4.creditorGgPersonResumeFile = JSON.parse(this.cForm4.creditorGgPersonResumeFile || '[]');
          this.cForm4.creditorFinanceReportFile = JSON.parse(this.cForm4.creditorFinanceReportFile || '[]');
          this.cForm4.creditorRiskResultFile = JSON.parse(this.cForm4.creditorRiskResultFile || '[]');
          this.cForm4.creditorCreditReportFile = JSON.parse(this.cForm4.creditorCreditReportFile || '[]');
          this.cForm4.creditorThinktankReportFile = JSON.parse(this.cForm4.creditorThinktankReportFile || '[]');

          // 债务人
          this.cForm4.debtorThreeCertOneFile = JSON.parse(this.cForm4.debtorThreeCertOneFile || '[]');
          this.cForm4.debtorIdentityCardFile = JSON.parse(this.cForm4.debtorIdentityCardFile || '[]');
          this.cForm4.debtorCompanyProfileFile = JSON.parse(this.cForm4.debtorCompanyProfileFile || '[]');
          this.cForm4.debtorCompanyByelawFile = JSON.parse(this.cForm4.debtorCompanyByelawFile || '[]');
          this.cForm4.debtorGgPersonResumeFile = JSON.parse(this.cForm4.debtorGgPersonResumeFile || '[]');
          this.cForm4.debtorFinanceReportFile = JSON.parse(this.cForm4.debtorFinanceReportFile || '[]');
          this.cForm4.debtorRiskResultFile = JSON.parse(this.cForm4.debtorRiskResultFile || '[]');
          this.cForm4.debtorCreditReportFile = JSON.parse(this.cForm4.debtorCreditReportFile || '[]');
          this.cForm4.debtorThinktankReportFile = JSON.parse(this.cForm4.debtorThinktankReportFile || '[]');
          
          // 增信主体
          this.subjectFile = this.cForm4.contractCreditorSubjectFile || {}
          for(let i=1; i <= this.cForm4.subjectNum; i++){
            this.subjectFile[`subjectThreeCertOneFile${i}`] = JSON.parse(this.subjectFile[`subjectThreeCertOneFile${i}`] || '[]');
            this.subjectFile[`subjectIdentityCardFile${i}`] = JSON.parse(this.subjectFile[`subjectIdentityCardFile${i}`] || '[]');
            this.subjectFile[`subjectCompanyProfileFile${i}`] = JSON.parse(this.subjectFile[`subjectCompanyProfileFile${i}`] || '[]');
            this.subjectFile[`subjectCompanyByelawFile${i}`] = JSON.parse(this.subjectFile[`subjectCompanyByelawFile${i}`] || '[]');
            this.subjectFile[`subjectGgPersonResumeFile${i}`] = JSON.parse(this.subjectFile[`subjectGgPersonResumeFile${i}`] || '[]');
            this.subjectFile[`subjectFinanceReportFile${i}`] = JSON.parse(this.subjectFile[`subjectFinanceReportFile${i}`] || '[]');
            this.subjectFile[`subjectRiskResultFile${i}`] = JSON.parse(this.subjectFile[`subjectRiskResultFile${i}`] || '[]');
            this.subjectFile[`subjectCreditReportFile${i}`] = JSON.parse(this.subjectFile[`subjectCreditReportFile${i}`] || '[]');
            this.subjectFile[`subjectThinktankReportFile${i}`] = JSON.parse(this.subjectFile[`subjectThinktankReportFile${i}`] || '[]');
          }
        } 
      }
    },
    methods: {  
      fontData(){
        // 债权人
        this.cForm4.creditorThreeCertOneFile = JSON.stringify(this.cForm4.creditorThreeCertOneFile||[]);
        this.cForm4.creditorIdentityCardFile = JSON.stringify(this.cForm4.creditorIdentityCardFile||[]);
        this.cForm4.creditorCompanyProfileFile = JSON.stringify(this.cForm4.creditorCompanyProfileFile||[]);
        this.cForm4.creditorCompanyByelawFile = JSON.stringify(this.cForm4.creditorCompanyByelawFile||[]);
        this.cForm4.creditorGgPersonResumeFile = JSON.stringify(this.cForm4.creditorGgPersonResumeFile||[]);
        this.cForm4.creditorFinanceReportFile = JSON.stringify(this.cForm4.creditorFinanceReportFile||[]);
        this.cForm4.creditorRiskResultFile = JSON.stringify(this.cForm4.creditorRiskResultFile||[]);
        this.cForm4.creditorCreditReportFile = JSON.stringify(this.cForm4.creditorCreditReportFile||[]);
        this.cForm4.creditorThinktankReportFile = JSON.stringify(this.cForm4.creditorThinktankReportFile||[]);

        // 债务人
        this.cForm4.debtorThreeCertOneFile = JSON.stringify(this.cForm4.debtorThreeCertOneFile||[]);
        this.cForm4.debtorIdentityCardFile = JSON.stringify(this.cForm4.debtorIdentityCardFile||[]);
        this.cForm4.debtorCompanyProfileFile = JSON.stringify(this.cForm4.debtorCompanyProfileFile||[]);
        this.cForm4.debtorCompanyByelawFile = JSON.stringify(this.cForm4.debtorCompanyByelawFile||[]);
        this.cForm4.debtorGgPersonResumeFile = JSON.stringify(this.cForm4.debtorGgPersonResumeFile||[]);
        this.cForm4.debtorFinanceReportFile = JSON.stringify(this.cForm4.debtorFinanceReportFile||[]);
        this.cForm4.debtorRiskResultFile = JSON.stringify(this.cForm4.debtorRiskResultFile||[]);
        this.cForm4.debtorCreditReportFile = JSON.stringify(this.cForm4.debtorCreditReportFile||[]);
        this.cForm4.debtorThinktankReportFile = JSON.stringify(this.cForm4.debtorThinktankReportFile||[]);

        // 增信主体
        for(let i=1; i <= this.cForm4.subjectNum; i++){
          this.subjectFile[`subjectThreeCertOneFile${i}`] = JSON.stringify(this.subjectFile[`subjectThreeCertOneFile${i}`]||[]);
          this.subjectFile[`subjectIdentityCardFile${i}`] = JSON.stringify(this.subjectFile[`subjectIdentityCardFile${i}`]||[]);
          this.subjectFile[`subjectCompanyProfileFile${i}`] = JSON.stringify(this.subjectFile[`subjectCompanyProfileFile${i}`]||[]);
          this.subjectFile[`subjectCompanyByelawFile${i}`] = JSON.stringify(this.subjectFile[`subjectCompanyByelawFile${i}`]||[]);
          this.subjectFile[`subjectGgPersonResumeFile${i}`] = JSON.stringify(this.subjectFile[`subjectGgPersonResumeFile${i}`]||[]);
          this.subjectFile[`subjectFinanceReportFile${i}`] = JSON.stringify(this.subjectFile[`subjectFinanceReportFile${i}`]||[]);
          this.subjectFile[`subjectRiskResultFile${i}`] = JSON.stringify(this.subjectFile[`subjectRiskResultFile${i}`]||[]);
          this.subjectFile[`subjectCreditReportFile${i}`] = JSON.stringify(this.subjectFile[`subjectCreditReportFile${i}`]||[]);
          this.subjectFile[`subjectThinktankReportFile${i}`] = JSON.stringify(this.subjectFile[`subjectThinktankReportFile${i}`]||[]);
        }
      
        this.cForm4.contractCreditorSubjectFile = this.subjectFile
      },
      prev() {
        this.fontData()
        sessionStorage.setpForm = JSON.stringify(this.cForm4);
        this.$emit('prev')
      },
      cSubmitForm(type) {         
        if(type == '0'){
          this.fontData()
          this.butLoading = true;
          this.cForm4.status = '0'
          this.$api.creditorsRights.addAndUpd(JSON.stringify(this.cForm4)).then(response => {
            this.butLoading = false;
            if(response.code == 200){
              sessionStorage.removeItem("setpForm")
              this.$message.success("保存成功");
              this.$router.go(-1);
            }     
          });
        }else{
          // 文件必填校验
          this.$refs["cForm4"].validate((valid) => {
            if ( valid ) {  
              this.$refs["subjectFile"].validate((valid) => {
                if ( valid ) {
                  this.fontData()
                  sessionStorage.setpForm = JSON.stringify(this.cForm4);
                  this.$emit('next');   
                }else {
                  this.$nextTick(() => {
                    elFormErrorScrollIntoView()
                  })
                }
              })                      
            }else {
              this.$nextTick(() => {
                elFormErrorScrollIntoView()
              })
            }
          }) 
        }     
              
      },   
      handleError(err, file, fileList){
        this.$message.error(file.name + "文件上传失败");
      },
      beforeUpload(file) { 	
        const isLt2M = file.size / 1024 / 1024 <= 80     //这里做文件大小限制
        
        if(!isLt2M) {
          this.$message.error('上传文件大小不能超过 80MB！');
        }
        return isLt2M
      },
      upload(response, file, list, name){
          if(response.code == 200){
            if(!this.cForm4[name]){
              this.cForm4[name] = []
            }
            this.$set(this.cForm4, name, [{
              name: response.name,
              url: response.url
            }])
            this.$refs.cForm4.clearValidate(name)
            
          }else{
            this.$set(this.cForm4, name, [])
            
            if(response.msg){
              this.$message.error(response.msg);
            }else {
              this.$message.error(file.name + "文件上传失败");
            }							
          }            
      },
      handleRemove(file, fileList, name) {
        this.$set(this.cForm4, name, [])      
      },
      uploadSub(response, file, list, name, i=''){
          if(response.code == 200){
            if(!this.subjectFile[name+i]){
              this.subjectFile[name+i] = []
            }
            this.$set(this.subjectFile, name+i, [{
              name: response.name,
              url: response.url
            }])
            this.$refs.subjectFile.clearValidate(name+i)
            
          }else{
            this.$set(this.subjectFile, name+i, [])
            
            if(response.msg){
              this.$message.error(response.msg);
            }else {
              this.$message.error(file.name + "文件上传失败");
            }							
          }            
      },
      handleRemoveSub(file, fileList, name,i = '') {
        this.$set(this.subjectFile, name+i, [])      
      },
    }
	}
</script>